import { licenceLogout } from './LicenceManagerApiServices';
import store from '../../redux/store';

export const licenceLogoutFromStore = () => {
  try {
    const { company, profile } = store.getState().localRedux || {};
    const companyCode = company?.companyCode;
    const userId = profile?.userId;
    if (!companyCode || !userId) return;

    licenceLogout({ customerId: companyCode, userId }).catch(() => { });
  } catch (_) {
    // ignore errors, logout call is best-effort
  }
};